export enum SnackbarNotificationMessageType {
    Error = 'ERROR',
    Info = 'INFO',
    Success = 'SUCCESS',
    Warning = 'WARNING',
    Debug = 'DEBUG',
}
